<template>
  <b-container fluid class="m-0 p-0">
    <!-- :::::::::::::::::::::::::::: SIDEBAR :::::::::::::::::::::::::::: -->
    <prioridade-sidebar @filtrar="filtrar($event)" @sorted="sorted($event)" />
    <!-- :::::::::::::::::::::::::::: DASHBOARD BODY :::::::::::::::::::::::::::: -->
    <div id="dashboard-body">
      <b-card-group deck>
        <div v-for="item of getSortDatePrioridades(filtro)" :key="item.id">
          <b-card :bg-variant="color(item)" text-variant="white" class="text-center m-2 card-size" @click="showItens(item)">
            <template #header>
              <h4 class="mb-0">
                <strong>{{ item.descricao }}</strong>
              </h4>
            </template>
            <b-container>
              <b-row class="text-center">
                <b-form-input v-model="item.cliente" disabled />
              </b-row>
              <b-row class="text-center">
                <b-form-input v-model="item.solicitante" disabled />
              </b-row>
              <b-row class="text-center">
                <b-form-input v-model="item.forma" disabled />
              </b-row>
            </b-container>
            <template #footer>
              <b-row class="text-center">
                <b-form-datepicker
                  class="ml-3 mr-3"
                  disabled
                  v-model="item.data"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                ></b-form-datepicker>
              </b-row>
            </template>
          </b-card>
        </div>
      </b-card-group>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <itens-dash-modal ref="dashboardsItensList" />
  </b-container>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import PrioridadeDashSideBar from "@/components/bars/PrioridadeDashSideBar";
import { usePrioridadeStore } from "@/stores/PrioridadeStore";
import ItensDashboardModal from "@/components/modals/armazem/ItensDashboardModal";

export default {
  name: "PaginaDashboardPrioridades",

  components: {
    "prioridade-sidebar": PrioridadeDashSideBar,
    "itens-dash-modal": ItensDashboardModal,
  },

  data() {
    return {
      filtro: {
        descricao: "",
        solicitante: "",
        cliente: "",
        status: "atendida",
      },
    };
  },

  methods: {
    showItens(item) {
      this.$refs.dashboardsItensList.call(item);
    },

    filtrar(filtro) {
      this.filtro.descricao = filtro.descricao;
      this.filtro.cliente = filtro.cliente;
      this.filtro.solicitante = filtro.solicitante;
    },

    sorted(status) {
      this.filtro.status = status;
    },

    color(item) {
      let color = "info";
      let data = new Date();
      var dataItem = new Date(item.data).getTime();

      data = new Date(data.getTime() + 3 * 24 * 60 * 60 * 1000);
      if (dataItem < data.getTime()) {
        color = "danger";
      }

      data = new Date(data.getTime() + 12 * 24 * 60 * 60 * 1000);
      if (dataItem < data.getTime() && color != "danger") {
        color = "warning";
      }

      if (item.status == "atendida") {
        color = "success";
      }

      return color;
    },
  },

  setup() {
    const store = useSgcqStore();
    const prioridadeStore = usePrioridadeStore();
    const { getItens } = storeToRefs(prioridadeStore);
    const { getSortDatePrioridades } = storeToRefs(prioridadeStore);

    return {
      store,
      prioridadeStore,
      getSortDatePrioridades,
      getItens,
      usuario: store.getUser,
    };
  },
};
</script>

<style lang="scss" scoped>
#dashboard-body {
  display: inline-block;
  width: 80%;
  vertical-align: top;
  overflow-x: hidden;
  overflow-y: scroll;
  min-width: 80%;
  height: 99vh;
}

.card-size {
  max-width: 20rem;
}
</style>
